import { render, staticRenderFns } from "./VulnerabilityDetailsModal.vue?vue&type=template&id=2409a4a1&scoped=true&"
import script from "./VulnerabilityDetailsModal.vue?vue&type=script&lang=js&"
export * from "./VulnerabilityDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./VulnerabilityDetailsModal.vue?vue&type=style&index=0&id=2409a4a1&lang=scss&"
import style1 from "./VulnerabilityDetailsModal.vue?vue&type=style&index=1&id=2409a4a1&scoped=true&lang=css&"
import style2 from "./VulnerabilityDetailsModal.vue?vue&type=style&index=2&id=2409a4a1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2409a4a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2409a4a1')) {
      api.createRecord('2409a4a1', component.options)
    } else {
      api.reload('2409a4a1', component.options)
    }
    module.hot.accept("./VulnerabilityDetailsModal.vue?vue&type=template&id=2409a4a1&scoped=true&", function () {
      api.rerender('2409a4a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/vulnerabilities/VulnerabilityDetailsModal.vue"
export default component.exports